import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import VueCookies from 'vue-cookies'
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
//import 'bulma/css/bulma.css';

const app = createApp(App);

app.use(router);
app.use(VueCookies, { expires: '360d'})
app.use(Vue3Toastify);

app.mount('#app');